import React from 'react'
import PropTypes from 'prop-types'

import sliteLogoImage from 'assets/images/slite-logo.svg'
import connectBackgroundImage from './connectBackground.svg'

import { PopupCenter } from 'lib/utils'
import { Button } from 'components/base'

export default class UserAssociation extends React.Component {
  static propTypes = {
    onUserAssociationDone: PropTypes.func.isRequired,
    userAddUrl: PropTypes.string.isRequired,
    application: PropTypes.shape({
      name: PropTypes.string.isRequired,
      photoURL: PropTypes.string.isRequired,
      labels: PropTypes.shape({
        userConnectIncentive: PropTypes.string.isRequired,
      }),
    }),
  }

  handleButtonClick = event => {
    const { userAddUrl } = this.props

    event.preventDefault()

    PopupCenter({
      url: userAddUrl,
      title: 'integration-user-association',
      requestedWidth: 600,
      requestedHeight: 800,
      onClose: () => {
        this.props.onUserAssociationDone()
      },
    })
  }

  render() {
    const { application, userAddUrl } = this.props

    return (
      <div className="slite-design-system">
        <div
          style={{
            height: 102, // 40px paddingTop + 62px background height
            position: 'relative',
            background: `url(${connectBackgroundImage}) no-repeat right bottom`,
            userSelect: 'none',
          }}
        >
          <div
            style={{
              position: 'absolute',
              left: 72,
              top: 56,
            }}
          >
            <img
              style={{ width: 32, height: 32 }}
              src={application.photoURL}
              alt={`${application.name} integration-logo`}
            />
          </div>
          <div style={{ position: 'absolute', right: 72, top: 56 }}>
            <img
              style={{ width: 32, height: 32 }}
              src={sliteLogoImage}
              alt="slite-logo"
            />
          </div>
        </div>
        <div className="padding-large">
          <div className="bold center-text">Connect to {application.name}</div>
          <div className="padding-top-small shade-20  center-text">
            {application.labels.userConnectIncentive}
          </div>
          <div className="center-text padding-top-large padding-bottom-medium">
            <Button.Primary
              className="inline-block"
              href={userAddUrl}
              onClick={this.handleButtonClick}
            >
              Link account
            </Button.Primary>
          </div>
        </div>
      </div>
    )
  }
}
